const Helpers = {
    formatDate: (date) => {
    const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Thêm 1 vì getMonth() trả về giá trị từ 0-11
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
}
export default Helpers;
